export default __webpack_public_path__ + "images/b737369a2895743c25cf4b02da9b3b01.png";